import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'default-layout',
  imports: [RouterOutlet],
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent {}
